// extracted by mini-css-extract-plugin
export var box = "_5t-1";
export var checkboxRow = "_5t-8";
export var checked = "_5t-2";
export var descriptionSpacer = "_5t-a";
export var disabled = "_5t-3";
export var icon = "_5t-6";
export var input = "_5t-0";
export var labelSpacer = "_5t-9";
export var medium = "_5t-5";
export var small = "_5t-4";
export var text = "_5t-7";